import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import { FormToggle } from '@ami/react/core';
import { formatDateLongMonth } from '@ami/react/core';

export default class ConfirmCompletionDateModalComponent extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onShowUpdated: PropTypes.func.isRequired,
    onConfirmCompletionDate: PropTypes.func.isRequired,
    shipment: PropTypes.any.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  state = {
    sendNotification: true,
  };

  hide = () => this.props.hideModal();

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.setState({ sendNotification: true });
    }
  }

  render() {
    const {
      show,
      shipment,
      onShowUpdated,
      onConfirmCompletionDate,
      submitting,
    } = this.props;
    return (
      <Modal
        title="Confirm Completion Date"
        okTitle="Save"
        cancelTitle="Cancel"
        show={show}
        showCancel={true}
        onOk={() => onConfirmCompletionDate(this.state.sendNotification)}
        onShowUpdated={onShowUpdated}
        submitting={submitting}
        closeOnOk={false}
      >
        <div className="confirm-completion-date-form">
          <div className="row">
            <div className="col">
              <p>
                Are you sure you want to confirm the completion date of{' '}
                {shipment && (
                  <strong>{formatDateLongMonth(shipment.shipmentDate)}</strong>
                )}
                ?
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <FormToggle
                label="Send notification?"
                checked={this.state.sendNotification}
                onChange={(sendNotification) =>
                  this.setState({ sendNotification })
                }
              />
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}
